export default "__VITE_ASSET__B$JW9$Sf__"